import { render, staticRenderFns } from "./MStoreFormRadioButtonGroup.vue?vue&type=template&id=b16888bc&scoped=true&"
import script from "./MStoreFormRadioButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./MStoreFormRadioButtonGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16888bc",
  null
  
)

export default component.exports